import AccessRequestTableOthers from 'components/AccessRequests/Tables/Others';
import { useTranslation } from 'react-i18next';
import { getColumns } from '../../util';
import { useSelector } from 'react-redux';
import { getRecordOverviewChartViewAccess } from 'store/authentication/selectors';

const AccessRequestsChartGroupsPage = (props) => {
  const { t } = useTranslation();

  const { edit: canEdit, remove: canDelete } = useSelector(
    getRecordOverviewChartViewAccess()
  );

  return (
    <AccessRequestTableOthers
      {...props}
      getColumns={getColumns}
      entitySingular={t('Chart Group')}
      entityPlural={t('Chart Groups')}
      canEdit={canEdit}
      canDelete={canDelete}
    />
  );
};

export default AccessRequestsChartGroupsPage;
